import { Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import gsap from "gsap";

type ScrollAnimatedPinProps = {
  children: React.ReactNode;
};

export const ScrollAnimatedPin = ({ children }: ScrollAnimatedPinProps) => {
  const pinRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!pinRef.current) return;
      gsap.to(pinRef.current, {
        scrollTrigger: {
          trigger: pinRef.current,
          start: "top top",
          end: "+=100%",
          pin: true,
          invalidateOnRefresh: true,
        },
      });
    }, pinRef);
    return () => ctx.revert();
  }, []);

  return (
    <Box
      ref={pinRef}
      width="100%"
      height="100svh"

      sx={{
        display: {xs: "none", md: "flex"},
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
};
